import React from "react";
import { Mail, Send } from "lucide-react";

const LEGAL_LINKS = [
  ["/legal/offer", "Публичная оферта"],
  ["/legal/privacy", "Конфиденциальность"],
  ["/legal/rules", "Правила платформы"],
  ["/legal/refund", "Возврат и обмен"],
  ["/legal/performer", "Соглашение исполнителя"],
  ["/legal/requisites", "Реквизиты"],
  ["/legal/contacts", "Контакты"],
];

const PUBLIC_PAGES = [
  ["/", "Главная"],
  ["/krasnodar/dlya-biznesa.html", "Для бизнеса: задания от организаций"],
  ["/krasnodar/podrabotka.html", "Подработка в Краснодаре"],
  ["/krasnodar/porucheniya.html", "Поручения в Краснодаре"],
  ["/krasnodar/tajnyj-pokupatel.html", "Тайный покупатель"],
  ["/krasnodar/uhod-za-mogiloj.html", "Мемориальный сервис"],
  ["/krasnodar/dostavka-bez-poezdok.html", "Доставка без поездок"],
];

// D2: единый футер — карта сайта, юрссылки, контакты promo@ / support@ / Telegram
export const SiteFooter = () => (
  <footer data-testid="site-footer" className="w-full mt-12" style={{ background: "var(--rv-navy)", color: "rgba(255,255,255,0.75)" }}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
      <div>
        <p className="font-semibold text-white mb-3" style={{ fontFamily: "Manrope,sans-serif" }}>Документы</p>
        <ul className="space-y-1.5">
          {LEGAL_LINKS.map(([href, label]) => (
            <li key={href}><a href={href} className="hover:text-white" data-testid={`footer-legal-${href.split("/").pop()}`}>{label}</a></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-semibold text-white mb-3" style={{ fontFamily: "Manrope,sans-serif" }}>Разделы</p>
        <ul className="space-y-1.5">
          {PUBLIC_PAGES.slice(0, 4).map(([href, label]) => (
            <li key={href}><a href={href} className="hover:text-white">{label}</a></li>
          ))}
          <li><a href="/legal/sitemap" className="hover:text-white" data-testid="footer-sitemap-link">Карта сайта</a></li>
        </ul>
      </div>
      <div>
        <p className="font-semibold text-white mb-3" style={{ fontFamily: "Manrope,sans-serif" }}>Контакты</p>
        <ul className="space-y-2">
          <li className="flex items-center gap-2"><Mail size={14} /><a href="mailto:support@reversia.ru" className="hover:text-white" data-testid="footer-support-email">support@reversia.ru</a><span className="text-xs opacity-60">поддержка</span></li>
          <li className="flex items-center gap-2"><Mail size={14} /><a href="mailto:promo@reversia.ru" className="hover:text-white" data-testid="footer-promo-email">promo@reversia.ru</a><span className="text-xs opacity-60">сотрудничество</span></li>
          <li className="flex items-center gap-2"><Send size={14} /><a href="https://t.me/reversia_ru" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-telegram">t.me/reversia_ru (@reversia_ru)</a></li>
        </ul>
      </div>
    </div>
    <div className="text-center text-xs pb-6" style={{ color: "rgba(255,255,255,0.45)" }}>© {new Date().getFullYear()} Реверсия. Все права защищены.</div>
  </footer>
);

export const HtmlSitemap = () => (
  <div className="reversia-card p-6" data-testid="html-sitemap">
    <h1 className="text-2xl font-bold mb-6" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-navy)" }}>Карта сайта</h1>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
      <div>
        <h2 className="font-semibold mb-3">Страницы</h2>
        <ul className="space-y-2">{PUBLIC_PAGES.map(([href, label]) => <li key={href}><a href={href} style={{ color: "var(--rv-teal)" }}>{label}</a></li>)}</ul>
      </div>
      <div>
        <h2 className="font-semibold mb-3">Документы</h2>
        <ul className="space-y-2">{LEGAL_LINKS.map(([href, label]) => <li key={href}><a href={href} style={{ color: "var(--rv-teal)" }}>{label}</a></li>)}</ul>
      </div>
    </div>
  </div>
);
